import { c, IllustrationFrame, sc, type IllustrationProps } from './Illustration';

/** Giver sees no list yet. Big curious eyes peeking over a gift box. */
export function PeekingEyes(props: IllustrationProps) {
  return (
    <IllustrationFrame {...props}>
      <circle
        cx="58"
        cy="74"
        r="20"
        style={{ fill: c('neutral.0'), stroke: sc('border.strong'), strokeWidth: 3 }}
      />
      <circle
        cx="102"
        cy="74"
        r="20"
        style={{ fill: c('neutral.0'), stroke: sc('border.strong'), strokeWidth: 3 }}
      />
      <circle cx="63" cy="70" r="8" style={{ fill: c('neutral.900') }} />
      <circle cx="107" cy="70" r="8" style={{ fill: c('neutral.900') }} />
      <circle cx="66" cy="67" r="2.5" style={{ fill: c('neutral.0') }} />
      <circle cx="110" cy="67" r="2.5" style={{ fill: c('neutral.0') }} />
      <rect x="22" y="86" width="116" height="56" rx="10" style={{ fill: c('blue.500') }} />
      <rect x="72" y="86" width="16" height="56" style={{ fill: c('gold.400') }} />
      <circle cx="40" cy="88" r="9" style={{ fill: c('gold.300') }} />
      <circle cx="120" cy="88" r="9" style={{ fill: c('gold.300') }} />
    </IllustrationFrame>
  );
}
